var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('a',{staticClass:"iubenda-white no-brand iubenda-embed iub-legal-only iub-body-embed",attrs:{"href":"https://www.iubenda.com/privacy-policy/79904406","title":"Privacy Policy"}},[_vm._v("Privacy Policy")])])}
var staticRenderFns = []

export { render, staticRenderFns }